import React, {ReactNode} from "react";
import './layout.scss';

interface Props {
    children: ReactNode,
    className?: string,
}

const HorizontalLayout = ({children, className = ''}: Props) => (
    <div className={['horizontalLayout', className].join(' ')}>
        {children}
    </div>
);

export default HorizontalLayout;